window.AppUtils = {
    formatHtml(text) {
        const TABS_AND_LINE_BREAKS_GLOBAL_REGEX = /\t|\n/g;
        return text
            .replaceAll(TABS_AND_LINE_BREAKS_GLOBAL_REGEX, " ")
            .split("  ")
            .join(" ")
            .split("  ")
            .join("")
            .trim();
    },
    htmlToDomNode(html) {
        const template = document.createElement("template");
        template.innerHTML = html.trim();
        return template.content.firstChild;
    },
};
